import { FullStory, isInitialized } from "@fullstory/browser";

export function getFullstoryUrl(): string {
  if (!isInitialized()) {
    return "";
  }

  try {
    return FullStory("getSession", { format: "url.now" }) ?? "";
  } catch {
    return "";
  }
}
